import freeTrialActivatedBanner from "@app/analytics/assets/freeTrialActivatedBanner.png";
import PRODUCTS from "@app/common/constants/products";
import { BillingPlan, MeetingPlatform } from "@app/common/types";
import Config from "@app/config";

import {
  CMOStep,
  FreeTrialStep,
  FreeTrialStepZoom,
  PlaybackStep,
} from "./Content";
import DemoVideoPreview from "../assets/DemoVideoPreview.png";
import MeetingTools from "../assets/MeetingTools.png";
import Playback from "../assets/Playback.png";

export interface TutorialStepConfig {
  id: string;
  image: string;
  title: string;
  content?: string[];
  customContent?: (...args: any) => JSX.Element;
  next?: {
    content: string;
  };
  isVideo?: boolean;
}

const CMO_SCREEN = {
  id: "chief_meeting_officer",
  image: DemoVideoPreview,
  title: "I’m Read, your Chief Meeting Officer!",
  customContent: CMOStep,
  next: {
    content: "Continue",
  },
  isVideo: true,
};

const MEETING_TOOLS_SCREEN = {
  id: "meeting_tools",
  image: MeetingTools,
  title: "Get Meeting Tools & Metrics in your next meeting",
  content: [
    `${PRODUCTS.MEETING_TOOLS} helps steer you towards better outcomes in real-time. In the app you’ll find meeting metrics for the meeting and individual participants.`,
    "Read will join your meeting as a participant and provide an in-meeting timer, engagement score, and talk time.",
  ],
  next: {
    content: "Next",
  },
};

const PLAYBACK_SCREEN = {
  id: "playback",
  image: Playback,
  title: "Playback your meeting with video and transcription",
  customContent: PlaybackStep,
  next: {
    content: "Next",
  },
};

const FREE_TRIAL_STARTED_SCREEN: TutorialStepConfig = {
  id: "free_trial_started",
  image: freeTrialActivatedBanner,
  title: `Hooray - you’ve started your ${Config.billing.trialDays}-day trial of Read Enterprise!`,
  customContent: FreeTrialStep,
  next: {
    content: "Preview Reports",
  },
};

const FREE_TRIAL_STARTED_SCREEN_ZOOM: TutorialStepConfig = {
  ...FREE_TRIAL_STARTED_SCREEN,
  title: "Hooray - you’ve started your 12-month Zoom trial of Read!",
  customContent: FreeTrialStepZoom,
};

const CONTENT_SCREENS: TutorialStepConfig[] = [
  CMO_SCREEN,
  MEETING_TOOLS_SCREEN,
  PLAYBACK_SCREEN,
];

const CONTENT_SCREENS_ZOOM: TutorialStepConfig[] = [
  CMO_SCREEN,
  {
    ...MEETING_TOOLS_SCREEN,
    id: "meeting_tools_zoom",
    content: [
      `${PRODUCTS.MEETING_TOOLS} helps steer you towards better outcomes in real-time. In the app you’ll find meeting metrics, talk time, and more.`,
      "With the Zoom app, Read will join your meeting as a participant and request to record in order to provide transcript, searchable playback, and other key insights after the meeting ends.",
    ],
  },
  PLAYBACK_SCREEN,
];

const getTutorialStepConfigs = ({
  plan,
  isTrial,
  client,
}: {
  plan: BillingPlan;
  isTrial: boolean;
  client: MeetingPlatform;
}) => {
  const screens = client === "zoom" ? CONTENT_SCREENS_ZOOM : CONTENT_SCREENS;

  if (isTrial) {
    const freeTrialScreen =
      plan === "zoom_bundle_trial"
        ? FREE_TRIAL_STARTED_SCREEN_ZOOM
        : FREE_TRIAL_STARTED_SCREEN;

    return [...screens, freeTrialScreen];
  }

  return screens;
};

export default getTutorialStepConfigs;
